import { useState } from "react";
import SocialGlassSummary from "../tabs/SocialGlassSummary";
import SocialGlassComment from "../tabs/SocialGlassComment";
import SocialGlassBreakdown from "../tabs/SocialGlassBreakdown";

const SideTab = ({ tab, onClick, tabSelected }) => (
  <div
    className={`delay-50 group mb-2 flex w-full max-w-[250px] cursor-pointer items-center justify-start gap-3 rounded-[8px] px-1 py-3 text-black transition ease-in-out hover:bg-[#FAD8DA] hover:text-[#DB4225] ${tabSelected === tab.title && "bg-[#FAD8DA]"} `}
    onClick={onClick}
  >
    <img src={tab.iconsrc} alt="icon" className="h-5 w-5" />
    <p
      className={`mb-0 text-left text-lg leading-none ${tabSelected === tab.title && "text-red-500 transition ease-in-out"}`}
    >
      {tab.title}
    </p>
  </div>
);

const sidetabs = [
  {
    title: "Summary",
    iconsrc: "/Summaryicon.svg",
  },
  {
    title: "Topics Breakdown",
    iconsrc: "/Breakdownicon.svg",
  },
  {
    title: "Comments",
    iconsrc: "/Commentsicon.svg",
  },
];

function SocialGlassReportContent() {
  const [tabSelected, setTabSelected] = useState("Summary");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const renderTabContent = () => {
    switch (tabSelected) {
      case "Summary":
        return <SocialGlassSummary />;
      case "Topics Breakdown":
        return <SocialGlassBreakdown />;
      case "Comments":
        return <SocialGlassComment />;
      default:
        return <SocialGlassSummary />;
    }
  };
  return (
    <>
      <section className="hidden h-[calc(100vh-74px)] flex-1 grid-cols-[260px_1fr] md:grid">
        <aside className="sticky top-0 min-h-[calc(100vh-74px)] overflow-y-auto border border-b border-[#E5E7EB] px-4 py-4">
          {sidetabs.map((tab) => (
            <SideTab
              key={tab.title}
              tab={tab}
              tabSelected={tabSelected}
              onClick={() => setTabSelected(tab.title)}
            />
          ))}
        </aside>
        <div className="h-[calc(100vh-74px)] w-full overflow-y-scroll px-2 py-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {renderTabContent()}
        </div>
      </section>

      <div className="flex flex-col items-center justify-center md:hidden">
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="my-4 rounded bg-gray-200 px-4 py-2 text-sm font-medium hover:bg-gray-300"
        >
          {isDropdownOpen ? "Close Menu" : "Open Menu"}
        </button>

        {isDropdownOpen && (
          <>
            <SearchBar className="block w-full px-2 sm:w-[672px] md:hidden" />
            {sidetabs.map((tab) => (
              <SideTab
                key={tab.title}
                tab={tab}
                onClick={() => setTabSelected(tab.title)}
              />
            ))}
            <div className="h-auto min-h-full w-full px-2 py-4">
              {renderTabContent()}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default SocialGlassReportContent;
